<template>
  <v-container class="px-6 px-sm-12">
    <PageHeader
      header-text="Account"
      :header-icon="'mdi-account'"
      :disableSiteChange="true"
    />
    <v-row>
      <v-col cols="12" md="6">
        <v-card min-height="400px">
          <FormToolbar :title="user.username" :showSubmitButton="false" />
          <v-card-text class="px-0">
            <v-list>
              <v-list-item>
                <v-list-item-icon
                  ><v-icon>mdi-account</v-icon></v-list-item-icon
                >
                <v-list-item-title>
                  {{ user.username }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>mdi-email</v-icon></v-list-item-icon>
                <v-list-item-title>
                  {{ user.userEmail }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon
                  ><v-icon>mdi-account-details</v-icon></v-list-item-icon
                >
                <v-list-item-title>
                  <v-chip
                    v-for="role in user.roles"
                    :key="user.roles.indexOf(role)"
                    :class="'ma-1 info'"
                    small
                    >{{ role }}</v-chip
                  >
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon
                  ><v-icon>mdi-map-marker</v-icon></v-list-item-icon
                >
                <v-list-item-title>
                  <v-chip
                    v-for="site in user.assignedSites"
                    :key="site.id"
                    :class="'ma-1 info'"
                    small
                    >{{ site.id }}</v-chip
                  >
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card min-height="400px">
          <ValidationObserver ref="form">
            <FormToolbar
              title="Change Password"
              :onSubmitClick="submit"
              :isSubmitting="submitting"
            />
            <v-form class="mt-1">
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <ValidationProvider
                      name="Current Password"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="currentPassword"
                        :error-messages="errors"
                        label="Current Password"
                        type="password"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <ValidationProvider
                      name="New Password"
                      rules="required|min:8|max:25|password"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="newPassword"
                        :error-messages="errors"
                        label="New Password"
                        :counter="25"
                        type="password"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <ValidationProvider
                      name="Confirm New Password"
                      rules="required|min:8|max:25|password"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="newPasswordConfirm"
                        :error-messages="errors"
                        label="Confirm New Password"
                        :counter="25"
                        type="password"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import PageHeader from '../components/ui/PageHeader.vue';
import FormToolbar from '../components/ui/FormToolbar.vue';
import '../validators';

export default {
  name: 'Account',
  components: {
    PageHeader,
    ValidationObserver,
    ValidationProvider,
    FormToolbar,
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      submitting: false,
    };
  },
  computed: {
    ...mapGetters({ user: 'userStore/getUser' }),
  },
  methods: {
    submit() {
      this.$refs.form.validate()
        .then((isValid) => {
          if (isValid) {
            this.submitting = true;
            const payload = {};
            payload.currentPassword = this.currentPassword;
            payload.newPassword = this.newPassword;
            payload.newPasswordConfirm = this.newPasswordConfirm;
            this.$store.dispatch('userStore/changePassword', payload)
              .then(() => {
                this.onSuccess('Password changed successful');
                this.resetFormValues();
                this.$nextTick(() => this.$refs.form.reset());
              })
              .catch((err) => this.onError(err.message))
              .finally(() => { this.submitting = false; });
          }
        });
    },
    resetFormValues() {
      this.currentPassword = '';
      this.newPassword = '';
      this.newPasswordConfirm = '';
    },
    onSuccess(message, data) {
      this.$toast.success(message);
    },
    onError(message, data) {
      this.$toast.error(message);
    },
  },
};
</script>

<style>
</style>
